import { PopulationBasedFundingStatus } from "@/Common/Models/UI/Enums";

class PopulationBasedFundingStatusUIModel {
    constructor(populationBasedFundingStatus: PopulationBasedFundingStatus) {
        this.Enum = populationBasedFundingStatus;
        this.VocabKey = `${PopulationBasedFundingStatus[populationBasedFundingStatus]}Label`;
    }

    public VocabKey: string;
    public Enum: PopulationBasedFundingStatus;
}

export { PopulationBasedFundingStatusUIModel };
